<template>
    <el-card shadow="never" class="aui-card--fill">
        <div class="mod-ums__memberbalancecharge">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-form-item>
                    <el-input v-model="dataForm.mobileNumber" placeholder="会员电话" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="dataForm.memberName" placeholder="会员姓名" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="dataForm.balanceType" placeholder="福袋类型" clearable>
                        <el-option
                                v-for="item in enumData.fudaiEnum"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <template>
                        <div class="block">
                            <el-date-picker
                                    v-model="dataForm.beginDate"
                                    type="date"
                                    :clearable="true"
                                    format="yyyy年MM月dd日"
                                    value-format="yyyy-MM-dd 00:00:00"
                                    placeholder="开始时间">
                            </el-date-picker>
                        </div>
                    </template>
                </el-form-item>
                <el-form-item>
                    <template>
                        <div class="block">
                            <el-date-picker
                                    v-model="dataForm.endDate"
                                    type="date"
                                    :clearable="true"
                                    format="yyyy年MM月dd日"
                                    value-format="yyyy-MM-dd 00:00:00"
                                    placeholder="结束时间">
                            </el-date-picker>
                        </div>
                    </template>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getDataList()">{{ $t('query') }}</el-button>
                </el-form-item>
                <!-- <el-form-item>
                     <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
                 </el-form-item>-->
            </el-form>
            <el-table v-loading="dataListLoading" :data="dataList" border
                      @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
                <el-table-column prop="memberName" label="会员姓名" header-align="center" align="center"></el-table-column>
                <el-table-column prop="mobileNumber" label="会员电话号" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="exchangeNo" label="领取编码" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="balanceType" label="营销券类型" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.balanceType===enumData.fudaiEnum.qiankundai.value" type="success">优果
                        </el-tag>
                        <el-tag v-else-if="scope.row.balanceType===enumData.fudaiEnum.zhufudai.value" type="success">现金
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="costVouterNum" label="消耗数" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="produceNum" label="产生数" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="createDate" label="拆券时间" header-align="center" align="center"></el-table-column>

            </el-table>
            <el-pagination
                    :current-page="page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="limit"
                    :total="total"
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="pageSizeChangeHandle"
                    @current-change="pageCurrentChangeHandle">
            </el-pagination>
        </div>
    </el-card>
</template>

<script>
    import mixinViewModule from '@/mixins/view-module'
    import enums from '@/utils/enums'

    export default {
        mixins: [mixinViewModule],
        data() {
            return {
                mixinViewModuleOptions: {
                    getDataListURL: '/ums/memberExchangeRecord/list',
                    getDataListIsPage: true,
                    exportURL: '/ums/memberbalancecharge/export'
                },
                operatTypes: [{
                    value: '1',
                    label: '乾坤袋'
                }, {
                    value: '2',
                    label: '祝福袋'
                }],
                dataForm: {
                    mobileNumber: '',
                    balanceType: null,
                    beginDate: null,
                    endDate: null,
                    memberName: ''
                },
                enumData: enums
            }
        },
        components: {},
        mounted() {
            console.log(enums)
        }
    }
</script>
